import { render, staticRenderFns } from "./W5.vue?vue&type=template&id=22f3fb55&scoped=true&"
import script from "./W5.vue?vue&type=script&lang=js&"
export * from "./W5.vue?vue&type=script&lang=js&"
import style0 from "./W5.vue?vue&type=style&index=0&id=22f3fb55&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f3fb55",
  null
  
)

export default component.exports